import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-134369cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card border-0 radius-7 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between" }, null, -1))
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Mês de referência "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Data do pagamento "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Pagamento "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Valor ")
  ])
], -1))
const _hoisted_7 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_9 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-muted fs-13"
}
const _hoisted_12 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-square-out" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "text-muted fs-13"
}
const _hoisted_17 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "shadow-none text-center text-muted py-4"
}, " Nenhum pagamento encontrado. ", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_22 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_23 = { "aria-label": "Paginação do histórico de pagamentos" }
const _hoisted_24 = { class: "pagination mb-0" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInvoiceHistory, (item, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.month) + "/" + _toDisplayString(item.year), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.status), 1),
                _createElementVNode("td", _hoisted_9, [
                  (item.date_payment_formatted)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.date_payment_formatted), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "Não pago"))
                ]),
                _createElementVNode("td", _hoisted_12, [
                  (item.payment_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.payment_url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "payment-history__link",
                        title: "Abrir link de pagamento",
                        "aria-label": "Abrir link de pagamento em uma nova aba"
                      }, _hoisted_15, 8, _hoisted_13))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "Indisponível"))
                ]),
                _createElementVNode("td", _hoisted_17, " R$ " + _toDisplayString(item.value_formatted), 1)
              ]))
            }), 128)),
            (!_ctx.getInvoiceHistory || _ctx.getInvoiceHistory.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getInvoiceHistoryPagination.last_page || 1) + " — Total de " + _toDisplayString(_ctx.getInvoiceHistoryPagination.total || (_ctx.getInvoiceHistory ? _ctx.getInvoiceHistory.length : 0)) + " pagamentos ", 1),
        _createElementVNode("nav", _hoisted_23, [
          _createElementVNode("ul", _hoisted_24, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                disabled: _ctx.currentPage <= 1
              }, " Anterior ", 8, _hoisted_25)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.getInvoiceHistoryPagination.last_page }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                disabled: _ctx.currentPage >= _ctx.getInvoiceHistoryPagination.last_page
              }, " Próxima ", 8, _hoisted_26)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}